import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { syncCollectionProducts } from "../../api/apiCollections";
import parseError from "../../utils/parseError";

/**
 * Hook to sync products for a collection
 */
export function useSyncCollectionProducts() {
    const queryClient = useQueryClient();

    const {
        mutate: syncProducts,
        isPending: isSyncing,
    } = useMutation({
        mutationFn: ({ id, product_ids }) => syncCollectionProducts(id, product_ids),
        onSuccess: (response) => {
            toast.success(response.message || "Products synced successfully");
            queryClient.invalidateQueries({ queryKey: ["collection"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to sync products");
        },
    });

    return {
        syncProducts,
        isSyncing,
    };
}
